import { all, call, takeEvery } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { getAllOrdersResponse, getOrderByIdResponse } from "../actions";
import { axiosPost } from "../../utils/common/axios";
import { today } from "../../constants/garmentCodes";
import { createEntitySagas, extractPayloadAndCallback, runOptimisticAction, selectUserId, toQuery } from "./sagaHelpers";

export const orderEntity = createEntitySagas({
  entity: "order",
  endpoint: "orders",
  label: "Order",
  scope: "company",
  computedFields: ["brandName", "designName", "fabricName", "coordinator", "lastUpdated", "colourMatrix", "estimate", "dispatch", "timeline"],
  selectSlice: (state) => state.order,
  listKey: "orders",
  types: {
    getAll: types.GET_ALL_ORDERS,
    getById: types.GET_ORDER_BY_ID,
    create: types.CREATE_ORDER,
    update: types.UPDATE_ORDER,
    remove: types.DELETE_ORDER,
  },
  actions: { getAllResponse: getAllOrdersResponse, getByIdResponse: getOrderByIdResponse },
});

// payload: { id, status, courier, trackingNumber, dispatchDate, packageCount, expectedDelivery, notes }
function* dispatchSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, status, ...dispatch } = payload;
  const timelineUserId = yield* selectUserId({});
  yield* runOptimisticAction({
    entity: "order",
    selectList: orderEntity.selectList,
    id,
    changes: { status, dispatch: { ...dispatch, orderId: id } },
    request: () => axiosPost(`orders/${id}/dispatch${toQuery({ status, timelineUserId })}`, dispatch),
    successMessage: "Order marked as dispatched",
    errorFallback: "Could not record dispatch",
    callback,
  });
}

// payload: { id, receiptStatus, receivedQty, receiptDate, condition, comments }
function* confirmReceiptSaga(action) {
  const { payload, callback } = extractPayloadAndCallback(action);
  const { id, receiptStatus, receivedQty, receiptDate, condition, comments } = payload;
  const timelineUserId = yield* selectUserId({});
  yield* runOptimisticAction({
    entity: "order",
    selectList: orderEntity.selectList,
    id,
    changes: {
      receiptStatus,
      receivedQty,
      receivedDate: receiptDate || today(),
      receivedCondition: condition,
      receivedComments: comments,
    },
    request: () =>
      axiosPost(`orders/${id}/confirm-receipt${toQuery({ receiptStatus, receivedQty, receiptDate, condition, comments, timelineUserId })}`),
    successMessage: "Receipt confirmed",
    errorFallback: "Could not confirm receipt",
    callback,
  });
}

export function* orderSaga() {
  yield all([
    call(orderEntity.watcher),
    takeEvery(types.DISPATCH_ORDER, dispatchSaga),
    takeEvery(types.CONFIRM_ORDER_RECEIPT, confirmReceiptSaga),
  ]);
}
